import { activityReducer } from './activity.reducer'
import { commonReducer } from './common.reducer'
import { dashboardReducer } from './dashboard.reducer'
import { initializeReducer } from './initialize.reducer'
import { loginReducer } from './login.reducer'
import { queryReducer } from './query.reducer'
import { employeeReducer } from './employee.reducer'
import { knowledgeReducer } from './knowledge.reducer'
import { feedbackReducer } from './feedback.reducer'

export const appReducer = {
  login: loginReducer,
  activity: activityReducer,
  common: commonReducer,
  initialize: initializeReducer,
  query: queryReducer,
  employee: employeeReducer,
  dashboard: dashboardReducer,
  knowledge: knowledgeReducer,
  feedback: feedbackReducer
}
